const FormRow: React.FC = ({ children }) => <div className="form-row">{children}</div>;

export default FormRow;
